import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/attributes";
import attributes from '../../models/workflow/attributes'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    attributes: [],
    new:[],
    edit: [],
    deleteItem: [],
    showAdd:false,
 
  },

  mutations: {
    setAtributs(state, data) {
      state.attributes = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data
    },
    setShowAdd(state, data) {
      state.showAdd = data
    },
    setIsEdit(state, data) {
      state.isEdit = data
    },
    setNew(state,data){
      state.new=data
    }
  },
  actions: {
    async getAttributes(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAttributes();

          state.commit("setAtributs",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },


      async edit(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.edit(state.state.edit).then(() => {
              let item = state.state.edit
              let options = state.state.attributes
              
              options = options.map((option)=>{
              if(option.operId != item.operid){
                return option
              }
              item = attributes.fromJson({
                operId:item.operid,
                nomOper:item.nombre,
                nivelId: item.level,
                nivel:item.nivel,
                nombreNivel:item.nombreNivel,
                fecDesde: item.from,
                fecHasta: item.haNoEx ? null : item.to,
               
              })
              return item
              })
  
              state.commit('setAtributs', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

      },
      async new(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.new(state.state.new).then(() => {
              let item = state.state.new
              let options = state.state.attributes
      
              let newItem = attributes.fromJson({
                operId: item.operId,
                nomOper:item.nombre,
                nivel:item.nivel,
                nivelId: item.nivelId,
                fecDesde: item.fecDesde,
                fecHasta: item.fecHasta,
              })
              options.push(newItem)
              state.commit('setAtributs', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
       await state.state.service.delete(state.state.deleteItem).then(() => {
       
        let options = state.state.attributes
       
        options = options.filter(option => {
          return option.operId != state.state.deleteItem
        })
          state.commit('setAtributs', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)
  
        }
      })
     
    },
  },
});
